// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"e2ea6d39","376":"f3aa4ea3","622":"d418ebd4","896":"b51793ce"}[chunkId] + ".chunk.css";
};